import { Row, Col } from "react-bootstrap";

import {
  buttonNameConstants,
  toastMessages,
  toastType,
} from "../../../../constants";
import {
  customToast,
  parseToThousandSeperatorDecimalNumber,
} from "../../../../shared/utility";
import InventoryOverviewThreeCards from "../../../../shared/components/inventoryOverviewThreeCards/InventoryOverviewThreeCards";
import EditCogsOffer from "./EditCogsOffer";
import AddInventoryModalSubmitButton from "../../../../shared/components/inventory/AddInventoryModalSubmitButton";

const AddBatchInventoryFooter = ({
  closeModal,
  data,
  handleCogsValueChange,
  cogsPrice,
  spinnerArray,
  handleResetBatch,
  ...props
}) => {
  const totalCost = data.totalCost;

  const handleCogsChange = (data) => {
    if (data?.value > 0) {
      handleCogsValueChange(data);
    } else {
      customToast(toastMessages.TOTAL_COST, toastType.ERROR);
    }
  };

  return (
    <>
      <Row className="m-0 mb-3 px-0">
        <Col md={6} className="ps-0">
          <Col md={12} className="h-100">
            <EditCogsOffer
              {...props}
              data={data}
              handleCogsChange={handleCogsChange}
              cogsPrice={totalCost}
              handleRefresh={handleResetBatch}
            />
          </Col>
        </Col>
        <Col md={6} className="pe-0">
          <InventoryOverviewThreeCards
            data={[
              { label: "Total Items", value: data.totalItems },
              {
                label: "Total Market Value",
                value:
                  "$" +
                  parseToThousandSeperatorDecimalNumber(
                    data.totalMarketPrice ?? 0
                  ),
              },
              {
                label: "Total Price",
                value:
                  "$" + parseToThousandSeperatorDecimalNumber(data.totalPrice),
              },
            ]}
          />
          <AddInventoryModalSubmitButton
            data={data}
            className="m-0 w-100 mt-3"
            inventoryArray={props.addBatchInventory}
            cancelButton={{
              label: buttonNameConstants.CANCEL,
              handleClick: () => closeModal(),
            }}
            submitButton={{
              label: buttonNameConstants.ADD_TO_INVENTORY,
              handleClick: props.handleSubmitAddBatchInventory,
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default AddBatchInventoryFooter;
